module.exports = __webpack_public_path__ + "static/hero4-mobile-f63cf9ae1e4ea27f0340f085655e65fb.png";